<script lang="ts">
import type { PopoverArrowProps } from '..'
import { PopoverArrow } from '..'

export interface DateRangePickerArrowProps extends PopoverArrowProps {}
</script>

<script setup lang="ts">
const props = defineProps<DateRangePickerArrowProps>()
</script>

<template>
  <PopoverArrow v-bind="props">
    <slot />
  </PopoverArrow>
</template>
